import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/auth/LoginForm';
import Logo from '../components/ui/Logo';
import { useAuth } from '../hooks/useAuth';

const LoginPage: React.FC = () => {
  const { login, loading, user } = useAuth();
  const navigate = useNavigate();

  // Rediriger si déjà connecté
  useEffect(() => {
    if (user && !loading) {
      const redirectPath = user.role === 'supervisor' 
        ? '/supervisor/dashboard' 
        : '/secretary/dashboard';
      navigate(redirectPath, { replace: true });
    }
  }, [user, loading, navigate]);

  const handleLogin = async (email: string, password: string) => {
    try {
      await login(email, password);
      // La redirection sera gérée par l'effet ci-dessus quand user sera mis à jour
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  // Afficher un loader pendant la redirection si déjà connecté
  if (user && !loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Redirection vers votre tableau de bord...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <Logo size="xl" showText={false} />
        </div>
        <h2 className="mt-6 text-center text-3xl font-bold text-gray-900">
          Connectez-vous à votre compte
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Ou{' '}
          <a 
            href="/register" 
            className="font-semibold text-blue-600 hover:text-blue-500 transition-colors"
          >
            créez un nouveau compte
          </a>
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-lg sm:rounded-xl sm:px-10 border border-gray-200">
          <LoginForm onSubmit={handleLogin} isLoading={loading} />
          
          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="text-center">
              <a
                href="/forgot-password"
                className="font-medium text-blue-600 hover:text-blue-500 text-sm"
              >
                Mot de passe oublié ?
              </a>
            </div>
            
            <div className="mt-4 text-center">
              <p className="text-xs text-gray-500">
                Vous êtes une institution ?{' '}
                <a 
                  href="/contact" 
                  className="text-blue-600 hover:text-blue-800 font-medium"
                >
                  Contactez-nous
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;